const EXTENSIONS = {
  "image/jpeg": "jpg", "image/png": "png", "image/gif": "gif", "image/webp": "webp", "image/heic": "heic", "image/heif": "heif", "image/avif": "avif", "image/svg+xml": "svg", "image/bmp": "bmp", "image/tiff": "tif",
  "video/mp4": "mp4", "video/webm": "webm", "video/quicktime": "mov", "video/3gpp": "3gp", "video/x-msvideo": "avi",
  "audio/mpeg": "mp3", "audio/mp3": "mp3", "audio/mp4": "m4a", "audio/aac": "aac", "audio/ogg": "ogg", "application/ogg": "ogg", "audio/opus": "opus", "audio/webm": "webm", "audio/wav": "wav", "audio/x-wav": "wav", "audio/flac": "flac", "audio/amr": "amr",
  "application/pdf": "pdf", "text/plain": "txt", "text/csv": "csv", "application/json": "json", "text/html": "html", "application/rtf": "rtf",
  "application/msword": "doc", "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "application/vnd.ms-excel": "xls", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "application/vnd.ms-powerpoint": "ppt", "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
  "application/zip": "zip", "application/x-zip-compressed": "zip", "application/x-7z-compressed": "7z", "application/vnd.rar": "rar", "application/x-rar-compressed": "rar", "application/gzip": "gz",
};
const extensionForMime = value => EXTENSIONS[String(value || "").split(";")[0].trim().toLowerCase()];
const hasExtension = name => /\.[a-z0-9]{1,10}$/i.test(name);
export const mimeForFilename = name => Object.keys(EXTENSIONS).find(mime => EXTENSIONS[mime] === String(name || '').split('.').pop().toLowerCase()) || '';
const cleanName = value => typeof value === "string" ? value.split(/[\\/]/).pop().replace(/[<>:"|?*]/g, "_").replace(/[\u0000-\u001f]/g, "_").trim().replace(/[. ]+$/, "") : ""; // eslint-disable-line no-control-regex

function responseName(header) {
  if (typeof header !== "string") return "";
  const encoded = header.match(/filename\*\s*=\s*UTF-8'[^']*'([^;]+)/i);
  if (encoded) { try { return decodeURIComponent(encoded[1].trim()); } catch { /* Fall back to filename. */ } }
  const plain = header.match(/filename\s*=\s*(?:"([^"]*)"|([^;]*))/i);
  return plain?.[1] || plain?.[2]?.trim() || "";
}

export function attachmentName(item, { blob, contentDisposition, extension } = {}) {
  const attachment = item.content?.attachment || {};
  const names = [item._localFile?.name, attachment.file_name, responseName(contentDisposition)].map(cleanName).filter(Boolean);
  const complete = names.find(hasExtension);
  if (complete) return complete;
  const name = names[0] || `${item.kind || "attachment"}-${String(item.id || "download").replace(/[^a-z0-9_-]/gi, "_")}`;
  const suffix = extensionForMime(blob?.type) || extensionForMime(item._localFile?.type) || extensionForMime(attachment.mime_type) || extension;
  return suffix ? `${name}.${suffix}` : name;
}

async function signatureExtension(blob) {
  const bytes = new Uint8Array(await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(blob.slice(0, 32));
  }));
  const text = String.fromCharCode(...bytes);
  if (text.startsWith("%PDF-")) return "pdf";
  if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return "jpg";
  if (bytes[0] === 0x89 && text.slice(1, 4) === "PNG") return "png";
  if (/^GIF8[79]a/.test(text)) return "gif";
  if (text.startsWith("RIFF") && text.slice(8, 12) === "WEBP") return "webp";
  if (text.startsWith("RIFF") && text.slice(8, 12) === "WAVE") return "wav";
  if (text.startsWith("OggS")) return "ogg";
  if (text.startsWith("fLaC")) return "flac";
  if (text.startsWith("ID3")) return "mp3";
  if (text.slice(4, 8) === "ftyp") {
    const brand = text.slice(8, 12);
    if (brand === "M4A ") return "m4a";
    if (brand === "qt  ") return "mov";
    if (["heic", "heix", "hevc", "hevx"].includes(brand)) return "heic";
    if (["avif", "avis"].includes(brand)) return "avif";
    if (["isom", "iso2", "mp41", "mp42", "avc1", "M4V ", "MSNV"].includes(brand)) return "mp4";
  }
  return null;
}

export async function downloadFilename(item, blob, contentDisposition) {
  const options = { blob, contentDisposition };
  const name = attachmentName(item, options);
  if (hasExtension(name)) return name;
  let extension;
  try { extension = await signatureExtension(blob); } catch { /* Unknown bytes stay generic, not mislabeled as a PDF/image. */ }
  return attachmentName(item, { ...options, extension: extension || "bin" });
}
